module.exports = __webpack_public_path__ + "assets/img/sdwan-module9-1.74c39298.jpg";